import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

export function useIsBackMarketPromiseEnabled() {
  const experiments = useExperiments()

  function isBackMarketPromiseEnabled() {
    return (
      experiments['experiment.backMarketPromise'] === 'withBackMarketPromise'
    )
  }

  return {
    isBackMarketPromiseEnabled,
  }
}
